import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authService } from '../api/services/authService';
import { useAuthStore } from '../store/authStore';
import { LoginDTO } from '../../../shared/types';
import { toast } from 'react-hot-toast';

export const useLogin = () => {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  return useMutation({
    mutationFn: (credentials: LoginDTO) => authService.login(credentials),
    onSuccess: (data) => {
      if (data.requires2FA) return; // Login.tsx will handle the 2FA step
      setAuth(data.user!, data.token!);
      toast.success('Login successful!');
      navigate('/');
    },
    onError: () => {
      toast.error('Invalid username or password');
    },
  });
};

export const useLogout = () => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);

  return useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      logout();
      navigate('/login');
      toast.success('Logged out successfully');
    },
  });
};

export const useAuth = () => {
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const hasRole = useAuthStore((state) => state.hasRole);
  const hasAnyRole = useAuthStore((state) => state.hasAnyRole);

  return {
    user,
    isAuthenticated,
    hasRole,
    hasAnyRole,
  };
};
